import React, {useState, useMemo, useCallback} from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import SlidePanel from "../../components/UI/SlidePanel/SlidePanel";
import classes from "./AddSubnet.css";
import Switch from '../../components/UI/Switch/Switch';
import { useEffect } from "react";
import Modal from '../../components/UI/Modal/Modal';
import { FaCheckCircle, FaExclamationTriangle, FaInfoCircle } from 'react-icons/fa';
import AddDeviceModal from "./AddDeviceModal";
import { getDeviceName } from "../../shared/common";
import * as actions from '../../store/actions/index';
import Box from '../../hoc/Box/Box';
import SelectDropdown from '../../shared/SelectDropdown/SelectDropdown';

const AddSubNetPanel = ({ showPanel, hidePanel, saveSubnet, selectedData, getDhcpReservations, ...extraProps }) => {

  const [state, setState] = useState({
        configType: '',
        baseAddress: "",
        keyValue: "",
        keyLength: "",
        keyId: ""
    });
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [ripKeyToggle, setRipKeyToggle] = useState(true);
  const [showAddDeviceModal, setShowAddDeviceModal] = useState(false);
  const [showDeleteSubnetConfirmationModal, setShowDeleteSubnetConfirmationModal] = useState(false);
  const [deviceToRemove, setDeviceToRemove] = useState();
  const [selectedDeviceSubnet, setSelectedDeviceSubnet] = useState();
  const [showDeviceAddedBanner, setShowDeviceAddedBanner] = useState(false);

    const onConfirmation = () => {
      extraProps.onDeleteStaticIpInfoDetails(
        selectedData.subnetId,
        ({ success, failure }) => {
          hidePanel()
        }
      );
    }

    const removeConfirmation = () => {
      extraProps.onDeleteIpReservation(deviceToRemove.mac, ({ success, failure }) => {
        setShowDeleteSubnetConfirmationModal(false);
        setDeviceToRemove('');
        if (success) {
          getDhcpReservations?.();
        }
      }, 'staticIp');
    };

    const resetState = () => {
        setState({
            configType: "",
            baseAddress: "",
            keyValue: "",
            keyLength: "",
            keyId: ""
        })
    }

  useEffect(() => {
    if (selectedData?.id) {
      getDhcpReservations?.()
    }
  }, [selectedData?.id])

  useEffect(() => {
      if(selectedData) {
          setState(selectedData)
      } else {
          resetState();
      }
      setShowDeviceAddedBanner(false);
  }, [selectedData]);

  useEffect(() => {
    setState(state => ({
      ...state,
      configType: extraProps.configType
    }))
  }, [extraProps.configType]);

  const handleInputChange = (event, name) => {
      const { value } = event;
      setState(copyState => ({
          ...copyState,
          [name]: value
      }))
  }
  const isDuplicateNetworkIp = () => {
    if (isEditMode) {
      return false;
    }
    const enteredBaseAddress = state.baseAddress?.trim();
    if (!enteredBaseAddress) {
      return false;
    }
    const normalizeIp = (ip) => {
      if (!ip) {
        return '';
      }
      const value = typeof ip === 'object' ? ip.ip : ip;
      return typeof value === 'string' ? value.trim() : '';
    };
    const takenIpAddresses = [];
    (extraProps.existingSubnets || []).forEach((subnet) => {
      if (!subnet) {
        return;
      }
      takenIpAddresses.push(normalizeIp(subnet.baseAddress));
      takenIpAddresses.push(normalizeIp(subnet.gatewayIPaddr));
      (subnet.usableIPaddr || []).forEach((usableIp) => {
        takenIpAddresses.push(normalizeIp(usableIp));
      });
    });
    return takenIpAddresses.includes(enteredBaseAddress);
  }

  const isFormValid = () => {
    if (isDuplicateNetworkIp()) {
      return false;
    }
    if(ripKeyToggle){
      return state.configType && state.keyLength?.trim()
      && state.baseAddress?.trim() && state.keyValue?.trim();
    }else{
      return state.configType && state.keyLength?.trim()
      && state.baseAddress?.trim();
    }

  }

  const handleDeleteStaticIP = () => {
    setShowConfirmationModal(true)
  }
  const onCancel = () => {
    setShowConfirmationModal(false);
  }

  const handleRemoveSubnet = (device) => {
    setDeviceToRemove(device)
    setShowDeleteSubnetConfirmationModal(true)
  }

  const onCloseAddModal = (suppress, deviceAdded) => {
    setShowAddDeviceModal(false);
    setSelectedDeviceSubnet('');
    if (deviceAdded) {
      setShowDeviceAddedBanner(true);
      setTimeout(() => setShowDeviceAddedBanner(false), 3000);
      // #7 refresh DHCP so IpReservations list and subnet list both update
      getDhcpReservations?.();
    }
    if (!suppress) {
      extraProps.resetDhcpErrorSuccess();
    }
  }

  const confirmationModal = (
    <Modal
      show={showConfirmationModal}
    >
      <div>
        <div style={{display:'flex',alignItems: 'center'}}>
          <FaInfoCircle color="#d13200" size={24} style={{ display: 'flex', marginRight: '5px', marginLeft: '5px'}} />
          <h1 id = 'StaticIPDelete' className={classes.deleteConfirmationModalTitle}>Remove Static IP Block</h1>
        </div>
        <div id = 'StaticIPDeleteMsg' > You are removing Static IP Block this will remove the subnet and all devices added to subnet IP addresses. Do you want to proceed?</div>
        <div className={classes.ButtonRow}>
          <button id = 'StaticIPProceed' className={classes.proceedButton} onClick={onConfirmation}>Proceed</button>
          <button id = 'StaticIPCancel' className={classes.CancelsButton} onClick={onCancel}>Cancel</button>
        </div>
      </div>
  </Modal>
  )
  const deviceName = deviceToRemove ? (getDeviceName(deviceToRemove, extraProps?.advancedDeviceIds)?.deviceName || deviceToRemove?.hostname || 'Add device list') : '';
  const removeSubnetModal = () => {
      return (
        <Modal
          show={showDeleteSubnetConfirmationModal}
        >
          <div style={{zIndex:1000}}>
            <div style={{display:'flex',alignItems: 'center'}}>
              {/* #6 warning icon (yellow) instead of error icon */}
              <FaExclamationTriangle color="#f5a623" size={24} style={{ display: 'flex', marginRight: '5px', marginLeft: '5px'}} />
              <h1 id = 'StaticIPDelete' className={classes.deleteConfirmationModalTitle}>Remove Device</h1>
            </div>
            <div id='StaticIPDeleteMsg' >
            Remove {deviceName} from {deviceToRemove?.ip}? The customer may need to restart their device to release the static IP. </div>
            <div className={classes.ButtonRow}>
              <button id = 'StaticIPProceed' className={classes.proceedButton} onClick={removeConfirmation}>Proceed</button>
              <button
                id = 'StaticIPCancel'
                className={classes.CancelsButton}
                onClick={() => {
                  setShowDeleteSubnetConfirmationModal(false);
                  setDeviceToRemove('');
                }}
              >
                Cancel
              </button>
            </div>
          </div>
      </Modal>
    );
  }

  const getSubnetAssignedDevices = useCallback(() => {
    const { staticIp, realDhcp, devicesByEquipment, dhcpError } = extraProps;
    let ipSubnetDevices = [];
    staticIp?.subnetDetails.map((subnet) => {
      if(state.baseAddress === subnet.baseAddress){
        ipSubnetDevices.push(...subnet.usableIPaddr);
        if (!dhcpError) {
          realDhcp?.map((dhcpItem) => {
            if(ipSubnetDevices.includes(dhcpItem.ip)){
              const index = ipSubnetDevices.indexOf(dhcpItem.ip);
              if(index > -1){
                ipSubnetDevices.splice(index, 1);
              }
              ipSubnetDevices.push({ ...dhcpItem });
            }
          })
        }
      }
    })
    return ipSubnetDevices;
  }, [extraProps])

  const assignedDevices = () => {
    const assignedSubnetDevices = getSubnetAssignedDevices();
    const dhcpError = extraProps.dhcpError;
   return ( <div className={classes.section}>
          <div className={classes.sectionHeader}>
            <div className={classes.flexContainer}>
                <span id=''>Available IP Addresses</span>
            </div>
            </div>
            <div className={classes.fieldContainer} style={{backgroundColor: '#fff', paddingRight: '15px', paddingLeft:'15px', paddingBottom: '64px', height: '300px', overflow: 'auto'}}>

                <table style={{borderCollapse: 'collapse', width: '100%'}}>
                    <thead>
                    <tr style={{width: 'auto',  borderBottom: '2px solid gray'}}>
                        <th
                    style={{
                        textAlign:'left',
                    color: 'black',
                    borderLeft: 'none',
                    borderRight: 'none',
                    textAlign: 'left',
                    paddingRight: '30px',
                    paddingBottom: '10px',
                    cursor: 'pointer',
                    fontWeight: 200
                    }}
                        >Device Name</th> 
                         <th style={{  textAlign:'left', cursor: 'pointer', paddingRight: '40px', fontWeight: 200, paddingBottom: '10px', }}
                        >Mac Address</th> 
                        <th style={{ textAlign:'left', cursor: 'pointer', paddingRight: '30px', fontWeight: 200, paddingBottom: '10px', }}
                        >Subnet IP Address</th>
                    </tr>

         </thead>
                    <tbody>
                      {assignedSubnetDevices?.map((device) => (
                        <tr style={{ borderBottom: '1px solid lightgrey'}}>
                          <td style={{paddingTop: '15px',textAlign:'left', height: '20px' }} >
                          { device?.ip ? (
                            <span>{getDeviceName(device, extraProps?.advancedDeviceIds).deviceName || 'Unknown'}</span>
                          ):(
                            <span
                              className={dhcpError ? undefined : classes.successStaticLink}
                              style={dhcpError ? { color: '#999' } : {}}
                              onClick={dhcpError ? undefined : () => {
                                setShowAddDeviceModal(true);
                                setSelectedDeviceSubnet(device?.ip ?? device);
                              }}
                            >{dhcpError ? '--' : 'Add Device'}</span>
                          )}</td>
                          <td style={{paddingTop: '15px',textAlign:'left', height: '20px'}}>{device?.mac ?? (dhcpError ? '--' : ' - ')}</td> 
                          <td style={{paddingTop: '15px',textAlign:'left',  height: '20px'}}>{device?.ip ?? device}</td>
                         {typeof device !== 'string'&&  <button style={{ paddingTop: '15px' }} id='removeSubnet' onClick={() => handleRemoveSubnet(device)} className={classes.deleteLink}> Remove</button>} 
                        </tr>
                      ))}
                    </tbody>
                </table>
                {removeSubnetModal()}

            </div>
         </div>
   );
  }
  function validateIpAddress(inputValue) {
    var pattern = /^[0-9A-F]{1,40}$/; // regular expression to match IPv6 address
    var ipPattern = /^([01]?[0-9]?[0-9A-F]{0,3})(:[0-5][0-9A-F]{0,2})?$/; // regular expression to match IPv4 address
    var ipAddress = inputValue.trim();

    if (!pattern.test(ipAddress) && !ipPattern.test(ipAddress)) {
      return false; // input value is not a valid IP address
    } else {
      return true; // input value is a valid IP address
    }
  }

  function validateIpV6Address(inputValue) {
    var pattern = /^[0-9A-F]{1,40}$/; // regular expression to match IPv6 address
    var ipAddress = inputValue.trim();

    if (!pattern.test(ipAddress)) {
      return false; // input value is not a valid IPv6 address
    } else {
      return true; // input value is a valid IPv6 address
    }
  }
  const isEditMode = !!selectedData?.id;
  // const isEditMode = true
  // || !!sessionStorage.getItem("userRoles")?.includes('staticIP');
  let prefConfigType = extraProps.configType;
    if(extraProps.configType === 'STATIC-DHCP'){
      prefConfigType = 'STATIC + DHCP';
    }else if(extraProps.configType === 'STATIC-DHCP-NAT'){
      prefConfigType = 'STATIC + NAT';
    }else if(extraProps.configType === 'STATIC-DHCP-NAT-WIRELESS'){
      prefConfigType = 'STATIC Wifi + NAT';
    }

  const keyIdOptions =  [{ value: '0', label: '0' },
                        { value: '1', label: '1'},
                        { value: '2', label: '2'},
                        { value: '9', label: '9'}];

  const configTypeOptions =  [{ value: 'STATIC', label: 'STATIC' },
                        { value: 'STATIC-DHCP', label: 'STATIC + DHCP'},
                        { value: 'STATIC-DHCP-NAT', label: 'STATIC + NAT'},
                        { value: 'STATIC-DHCP-NAT-WIRELESS', label: 'STATIC Wifi + NAT'}];

  const keyLengthOptions =  [{ value: '30', label: '1' },
                        { value: '29', label: '5'},
                        { value: '28', label: '13'},
                        { value: '27', label: '29'}];

  return (
    <SlidePanel devDeets='true' show={showPanel} modalClosed={hidePanel} backgroundColor='#f7f7f7' scrollable={true}>
      {isEditMode && <button
            id='BackDevicesList'
            className={classes.RegularButton}
            style={{ marginTop: '2px' }}
            onClick={hidePanel}
          >
            {'<'} Back
          </button>}
      <Box>
        <div className={classes.subnetPanelContainer}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <strong id='createSubNetText'>{isEditMode ? `View/Edit Subnet ${Number(state.id) + 1 || ''}` : "Create Subnet"}</strong>
          {isEditMode && sessionStorage.getItem("userRoles")?.includes('staticIP') && <button id= 'StaticIPDelete' onClick={handleDeleteStaticIP} className={classes.deleteLink}>Delete Static IP Block</button>}
          </div>
          {confirmationModal}
          {showDeviceAddedBanner && (
            <div style={{ display: 'flex', alignItems: 'center', backgroundColor: '#c1f3c1', padding: '0.75rem 1rem', marginBottom: '1rem', borderRadius: '4px' }}>
              <FaCheckCircle color="green" size={20} style={{ marginRight: '8px', flexShrink: 0 }} />
              <span>Device added successfully. The customer may need to restart their device to activate the new static IP.</span>
            </div>
          )}
          <div className={classes.section}>
            <div className={classes.sectionHeader}>Select Configuration Type</div>
            <div className={classes.fieldContainer}>
              <label id='IPConfigType'>IP Configuration Type</label>
              {isEditMode || extraProps.configType ? (
                <input disabled={isEditMode} className={classes.InputElement} name="configType"
                value={prefConfigType}  />
              ) : (
                <SelectDropdown
                  height={'30px'}
                  width={'150px'}
                  name="configType"
                  id="AddSubNetConfig"
                  placeholder='Select Type'
                  defaultValue={state.configType}
                  options={configTypeOptions}
                  isSearchable={false}
                  onChange={(e) => {
                    handleInputChange(e, "configType")}
                  }
                />
              )
            }

            </div>
          </div>

          {(state.configType || extraProps.configType) &&
              <><div className={classes.section}>
            <div className={classes.sectionHeader}>IP & Length</div>
            <div className={classes.flexContainer}>
              <div className={classes.fieldContainer}>
                <label>Network IP Address</label>
                <input id='netWorkIP' disabled={isEditMode} placeholder='Enter Network IP'  className={classes.InputElement} name="baseAddress" value={state.baseAddress} onChange={(e) => {
                      handleInputChange(e.target, "baseAddress")}
                    } />
                {isDuplicateNetworkIp() && (
                  <span id='netWorkIPError' className={classes.errorMessage}>
                    This Network IP Address already exists. Please enter a different one.
                  </span>
                )}
              </div>
              <div className={classes.fieldContainer}>
                <label>Select Length</label>
                { isEditMode ? (
                  <input disabled={isEditMode} className={classes.InputElement} name="keyLength"
                  value={selectedData.length == '30' ? '1' : selectedData.length == '29' ? '5' : selectedData.length == '28' ?'13' : selectedData.length == '27' ? '29' : ''} />
                ) : (
                  <SelectDropdown
                    height={'30px'}
                    width={'150px'}
                    name="keyLength"
                    id="subNetLength"
                    placeholder='Select Length'
                    defaultValue={isEditMode ? selectedData.length :state.keyLength}
                    options={keyLengthOptions}
                    isSearchable={false}
                    onChange={(e) => {
                      handleInputChange(e, "keyLength")}
                    }
                  />
                )}
              </div>
            </div>
          </div>
            {!isEditMode && (
             <div className={classes.section}>
             <div className={classes.sectionHeader}>
               <div className={classes.flexContainer}>
                  <span>Use Rip Key</span>
                  <Switch
                    id="ripkeyenabletoggle"
                    aria-checked={ripKeyToggle}
                    aria-label='rip key enable'
                    onText='ON'
                    offText='OFF'
                    onChange={() => { setRipKeyToggle(!ripKeyToggle) }}
                    checked= {ripKeyToggle}
                  />
               </div>
           </div>
           {ripKeyToggle &&
           <div className={classes.flexContainer}>
           <div className={classes.fieldContainer}>
             <label id='subNetRIPKey'>Enter Rip Key</label>
             <input id='pasteRipKey' disabled={isEditMode ||!ripKeyToggle } placeholder="Paste RIP Key" className={classes.InputElement} name="keyValue" value={state.keyValue} onChange={(e) => {
              handleInputChange(e.target, "keyValue")} } />
           </div>
           <div className={classes.fieldContainer}>
               <label>SELECT RIP ID</label>
               { isEditMode ? (
                 <input disabled={isEditMode} className={classes.InputElement} name="keyId"
                 value={selectedData.keyId ?? state.keyId} />
               ) : (
                <SelectDropdown
                  height={'30px'}
                  width={'150px'}
                  name="keyId"
                  placeholder='SELECT RIP ID'
                  disabled={!ripKeyToggle}
                  defaultValue={isEditMode ? selectedData.keyId :  state.keyId}
                  options={keyIdOptions}
                  isSearchable={false}
                  onChange={(e) => {
                    handleInputChange(e, "keyId")}}
                />
               )}
             </div>
         </div>
           }

           </div>
            )}


          { isEditMode &&  assignedDevices() }
          </>}

          {!isEditMode && <div className={`${classes.ButtonRow} ${classes.containerSpace}`}>
          <button  id='subNetSave' className={classes.SaveButton} disabled={!isFormValid() || isEditMode} onClick={()=> {
            saveSubnet(state, ripKeyToggle)

           }}>Save</button>
            <button id='subNetCancel' className={classes.CancelButton} onClick={hidePanel}>
              Cancel
            </button>
          </div>}
        </div>
      </Box>
        {showPanel && showAddDeviceModal &&
            <Modal show={showAddDeviceModal} modalClosed={() => { onCloseAddModal() }} customStyle={{ zIndex: 490 }}>
              <AddDeviceModal
            hideModal={(suppress, deviceAdded) => {
              onCloseAddModal(suppress, deviceAdded)
            }
            }
            devices={extraProps.devicesByEquipment}
            advancedDeviceIds={extraProps.advancedDeviceIds}
            selectedDeviceSubnet={selectedDeviceSubnet}
            onAddIpReservation={extraProps.onAddIpReservation}
            realDhcp={extraProps.realDhcp}
              />
            </Modal>
      }

    </SlidePanel>
  );
};

const mapStateToProps = (state) => ({
  staticIp : state.staticIp.staticIp,
  staticIpSuccess: state.staticIp.staticIpSuccess,
  staticIpFail: state.staticIp.staticIpFail,
  staticIpMesssage: state.staticIp.staticIpFailureMesssage,
  staticIpLoading: state.staticIp.staticIpLoading,
  staticIpDeleteFailureMesssage: state.staticIp.staticIpDeleteFailureMesssage,
  realDhcp: state.dhcp.realDhcp,
  dhcpError: state.dhcp.dhcpError,
  devicesByEquipment: state.devices.devicesByEquipment,
  advancedDeviceIds: state.devices.advancedDeviceIds,

});

const mapDispatchToProps = (dispatch) => {
  return {
    resetDhcpErrorSuccess: () => dispatch(actions.resetDhcpErrorSuccess()),
    onResetDhcpErrorSuccess: () => dispatch(actions.resetDhcpErrorSuccess()),
    onDeleteIpReservation: (devMac, callback, requestedFrom) => dispatch(actions.deleteIpReservation({ devMac, callback}, requestedFrom))
  }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddSubNetPanel));